import { defineManifest } from '@ndrc/app-sdk/manifest';
import fr from './messages/fr.json' with { type: 'json' };
export const manifest = defineManifest({
  id: 'parcours',
  name: fr.title,
  description: 'Reconstituer et analyser un parcours client.',
  icon: 'route',
  color: 'teal',
  glyph: [{ d: 'M5 6h8a4 4 0 0 1 0 8H9a4 4 0 0 0 0 8' }, { d: 'M3 4h4v4H3zM17 16h4v4h-4z' }],
  version: '0.1.0',
  sdk: '0.0.0',
  status: 'dev',
  category: 'relation-client',
  permissions: {
    uses: ['app.records.read', 'app.records.write', 'classroom.roster.read', 'classroom.assign'],
    defines: [],
  },
  entities: {
    uses: [],
    owns: [
      {
        table: 'scenarios',
        scope: 'class',
        description: 'Scénarios pédagogiques et corrigés, servis par le professeur.',
      },
      {
        table: 'exercises',
        scope: 'class',
        description: 'Exercices de la classe et instantanés des scénarios.',
      },
      {
        table: 'cards',
        scope: 'workspace',
        sharing: 'pair',
        description: 'Cartes, réponses et retours pédagogiques de cet espace.',
      },
    ],
  },
  events: { emits: [], subscribes: [] },
  ui: {
    student: { defaultRoute: '/', routes: [{ path: '/', title: fr.title }], layout: 'full' },
    teacher: { panel: true, widgets: [], studentInspector: true },
  },
  migrations: { schema: 'app_parcours', dir: 'migrations' },
});
